import(/* webpackMode: "eager" */ "/vercel/path0/app/map/page.tsx");
